export default __webpack_public_path__ + "static/media/Mohammed.aed19ab0.webp";